import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const employeeReceivableApi = factory.get("employeeReceivable");
const ordersApi = factory.get("orders");

const initialTransfer = {
  dialog: false,
  loading: false,
  employee: null,
  item: null,
};

const initialState = {
  receivables: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      employee_id: null,
      item_id: null,
      department_id: null,
    },
    dialog: false,
    transfer: { ...initialTransfer },
  },
};

export const employeeReceivableSlice = createSlice({
  name: "employeeReceivable",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.receivables.loading = !state.receivables.loading;
    },
    setData: (state, action) => {
      state.receivables.data = action.payload.data.data;
      state.receivables.total = action.payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.receivables.filters = {
        ...state.receivables.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.receivables.filters = initialState.receivables.filters;
    },
    setFiltersDialog: (state) => {
      state.receivables.dialog = !state.receivables.dialog;
    },
    openTransfer: (state, { payload }) => {
      state.receivables.transfer = {
        ...initialTransfer,
        dialog: true,
        employee: payload.employee,
        item: payload.item,
      };
    },
    closeTransfer: (state) => {
      state.receivables.transfer = { ...initialTransfer };
    },
    setTransferLoading: (state) => {
      state.receivables.transfer.loading = !state.receivables.transfer.loading;
    },
  },
});

export const {
  setLoading,
  setData,
  setFilters,
  resetFilters,
  setFiltersDialog,
  openTransfer,
  closeTransfer,
  setTransferLoading,
} = employeeReceivableSlice.actions;

export default employeeReceivableSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().employeeReceivable.receivables.filters;
    dispatch(setLoading());
    const res = await employeeReceivableApi.index({
      page: filters.page,
      skip: filters.skip,
      take: filters.take,
      employee_id: filters.employee_id?.id,
      item_id: filters.item_id?.id,
      department_id: filters.department_id?.id,
    });
    dispatch(setData(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Failed to fetch data",
      })
    );
    throw new Error(err);
  }
};

const transfer = (data) => async (dispatch) => {
  try {
    dispatch(setTransferLoading());
    const formdata = new FormData();
    formdata.append("from_type", "User");
    formdata.append("from_id", data.from_id);
    formdata.append("to_type", data.to_type);
    if (data.to_id?.id) {
      formdata.append("to_id", data.to_id.id);
    }
    formdata.append("type", "transfer");
    formdata.append("status", "pending");
    formdata.append("date", dayjs().format("YYYY-MM-DD"));
    if (data.ticket_id?.id) {
      formdata.append("ticket_id", data.ticket_id.id);
    }
    formdata.append("items", JSON.stringify(data.items));

    await ordersApi.create(formdata);
    dispatch(setTransferLoading());
    dispatch(
      showNotification({
        type: "success",
        message: "Item transferred successfully",
      })
    );
    dispatch(closeTransfer());
    dispatch(index());
  } catch (err) {
    dispatch(setTransferLoading());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Failed to transfer item",
      })
    );
  }
};

export const EmployeeReceivable = {
  index,
  transfer,
};
